<script>
  import { onMount } from 'svelte';

  import ProductFilterItem from '../../components/ProductFilterItem.svelte';
  import ProductInfoSublimation from '../../components/ProductInfoSublimation.svelte';
  import ProductInfoClassic from '../../components/ProductInfoClassic.svelte';

  export let products;
  export let category;
  export let collection;
  export let preferredGender = 'mens';
  export let title = 'Popular Products';
  export let isSublimation = false;

  function determineMainWidth() {
    if (typeof window !== 'undefined') {
      let documentWidth = window.innerWidth;

      mainWidth = documentWidth;
    }
    return mainWidth;
  }

  let overrideDesignerProduct = false;

  // prep item details for gtag
  let items = [];
  for (let i = 0; i < products.length; i++) {
    let product = products[i];
    let item = {
      index: i,
      id: product.id,
      name: product.name,
      slug: product.slug,
      price: (product.price / 100).toFixed(2),
      quantity: 1,
      currency: 'AUD',
      item_category: category,
      item_category2: collection,
      item_category3: false,
      item_list_name: `${category}-${collection}`,
    };
    items.push(item);
  }

  function setIsMobileIsTablet(mainWidth) {
    if (mainWidth && mainWidth < tabletBreakPoint) {
      isTablet = true;
      isMobile = false;
    }

    if (mainWidth && mainWidth <= mobileBreakPoint) {
      isTablet = false;
      isMobile = true;
    }

    if (mainWidth && mainWidth >= tabletBreakPoint) {
      isTablet = false;
      isMobile = false;
    }
  }

  function resize() {
    mainWidth = determineMainWidth();
    setIsMobileIsTablet(mainWidth);
  }

  let mainWidth;
  let isMobile = false;
  let isTablet = false;

  const mobileBreakPoint = 600;
  const tabletBreakPoint = 1000;

  onMount(() => {
    // GTAG - Add view product list
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'view_item_list',
      ecommerce: {
        items: items,
      },
    });

    // FB Pixel - Add view product list
    const contentIds = items.map((item) => item.name);
    if (typeof fbq !== 'undefined') {
      fbq('track', 'ViewContent', {
        content_name: 'View Popular Products',
        content_type: 'view popular products',
        content_ids: contentIds,
        contents: JSON.stringify(items),
      });
    }
    mainWidth = determineMainWidth();
    setIsMobileIsTablet(mainWidth);
  });
</script>

<svelte:window on:resize={resize} />
<div class="container">
  <h2>{title}</h2>
  {#if products?.length > 0}
    <div class="products">
      {#each products as product, i}
        {#if isMobile && i === 0}
          <div class="product-type-info">
            {#if isSublimation}
              <ProductInfoSublimation />
            {:else}
              <ProductInfoClassic />
            {/if}
          </div>
        {/if}
        <ProductFilterItem
          item={product}
          key={product.slug}
          {preferredGender}
          {overrideDesignerProduct}
          itemListName={`${category}-${collection}`}
        />
        {#if (!isMobile && isTablet && i === 0) || (!isMobile && !isTablet && products.length === 1)}
          <div class="product-type-info">
            {#if isSublimation}
              <ProductInfoSublimation />
            {:else}
              <ProductInfoClassic />
            {/if}
          </div>
        {/if}
        {#if !isMobile && !isTablet && i === 1}
          <div class="product-type-info">
            {#if isSublimation}
              <ProductInfoSublimation />
            {:else}
              <ProductInfoClassic />
            {/if}
          </div>
        {/if}
      {/each}
    </div>
  {/if}
</div>

<style>
  .container {
    margin: auto;
  }

  h2 {
    font-size: 3rem;
    text-align: center;
    margin-bottom: 3rem;
    font-family: 'Oswald';
    text-transform: uppercase;
    color: #1b285d;
  }

  .products {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-gap: 4rem;
    row-gap: 4rem;
  }

  .product-type-info {
    grid-column: 1 / -1;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 2rem;
    background-color: #f7f7f7;
    border-radius: 1rem;
  }

  @media screen and (min-width: 600px) {
    .products {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }

    .product-type-info {
      grid-column: span 2;
    }
  }

  @media screen and (min-width: 1000px) {
    .products {
      grid-template-columns: repeat(4, minmax(0, 1fr));
    }
  }
</style>
